<template>
	<div class="header">
		<!-- 折叠按钮 -->
		<div class="collapse-btn" @click="collapseChage">
			<el-icon  v-if="sidebar.showMobileSideBar ?!sidebar.collapseMobile : !sidebar.collapse ">
				<Expand />
			</el-icon>
			<el-icon  v-else>
				<Fold />
			</el-icon>
		</div>
		<div class="logo" @click="goHome">{{ userInfo.title }}
      </div>
		<div class="header-right">
      <!-- 暗黑模式 -->
      <div class="theme-mode">
        <el-icon  class="i-icon" @click="toggleTheme(1)" v-if="themeMode ==0"><Sunny /></el-icon>
        <el-icon class="i-icon light-icon" @click="toggleTheme(0)"  v-if="themeMode ==1"><Moon /></el-icon>
      </div>
      <!-- 通知 -->
      <!-- notifyCount -->
      <!-- <div class="notify">
        <el-tooltip effect="dark" content="notice" placement="bottom">
          <el-badge :value="9" :max="99" class="item">
            <el-icon ><BellFilled /></el-icon>
          </el-badge>
        </el-tooltip>
      </div> -->
      <div class="full-screen">
        <el-tooltip effect="dark" content="screenfull" placement="bottom"> 
          <!-- <i class="iconfont icon-fangda" v-show="!isFullScreen" @click.prevent="screenfull"></i> -->
          <el-icon @click.prevent="screenfull"><FullScreen /></el-icon>
        </el-tooltip>
        
        
      </div>
			<div class="header-user-con">
				<!-- 用户名下拉菜单 -->
				<el-dropdown class="user-name" trigger="click" @command="handleCommand">
					<span class="el-dropdown-link">
						Hi, {{ userInfo?.username }}
						<el-icon class="el-icon--right">
							<arrow-down />
						</el-icon>
					</span>
					<template #dropdown>
						<el-dropdown-menu>
							<el-dropdown-item divided command="password">Change password</el-dropdown-item>
              <el-dropdown-item divided command="loginout">Log out</el-dropdown-item>
						</el-dropdown-menu>
					</template>
				</el-dropdown>
			</div>
		</div>
  <password-dialog v-model:dialogVisible="passworddialogVisible"/>
	</div>
</template>

<script setup>
  import PubSub from "pubsub-js";
	import { onMounted, ref, computed,onUnmounted } from "vue";
	import { useSidebarStore } from "../stores/sidebar";
	import { useUserInfoStore } from "../stores/userInfoStore";
	import { useRouter } from "vue-router";
	import $http from "@/api";
  import passwordDialog from "@/components/passwordDialog.vue";
  import { sharedState } from '../hooks/sharedState';
	const { userInfo } = useUserInfoStore();
	// userInfo.getUserInfo();
  // console.log(userInfo,'0999',userInfo.getUserInfo(),'zfcdsfds')
  const passworddialogVisible = ref(false);
	const sidebar = useSidebarStore();
	// 侧边栏折叠
	const collapseChage = () => {
		sidebar.handleCollapse();
    PubSub.publish("drawerStatus",{status:true});
	};
  //屏幕宽度
  var screenWidth = ref(document.body.clientWidth);
  // var sidebarMobile = ref(false);

  // 创建一个计算属性
  // const reversedMessage = computed(() => {
  //   if (document.body.clientWidth < 1000) {
  //     return false;
  //   } else return true;
  // });
  // console.log(reversedMessage.value,'reversedMessage')
  // 监听窗口大小变化更新屏幕宽度
  // 尺寸小于1000 显示浮动菜单
  const updateScreenWidth = () => {
    // console.log('updateScreenWidth',document.body.clientWidth)
    screenWidth.value = document.body.clientWidth;
    if (screenWidth.value < 1000) {
			// collapseChage();
      sidebar.showMobileSideBar = true; //展示移动端侧边栏
      sidebar.collapse = true; //侧边栏折叠状态
      sidebar.collapseMobile = true; //浮动菜单折叠状态默认关闭
      // console.log('updateScreenWidth<1000')
      
		} else {
      // console.log('collapseChage111',screenWidth.value)
      sidebar.showMobileSideBar = false;
      sidebar.collapse = false;
      sidebar.collapseMobile = true; //浮动菜单折叠状态默认关闭


    }
    // console.log(sidebar.showMobileSideBar,'当前窗口宽度')
    
  };
  // 判断是不是平板手机
  // const isMobile = computed(() => {
  //   if (screenWidth.value < 1000) {
  //     return true;
  //   } else return false;
  // });
  // console.log(isMobile.value,'isMobile')
  const isIpadFun = () => {
    var ua = navigator.userAgent;
    var ipad = ua.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/);
    if (ipad) {
      return true;
    } else {
      return false;
    }
  };
  const isIpad = isIpadFun();

	onMounted(() => {
    // 监听窗口大小变化
    window.addEventListener('resize', updateScreenWidth);
    //console.log('onMounted',document.body.clientWidth)
		if (document.body.clientWidth < 1000) {
			collapseChage();
      //console.log('collapseChage')
		}

    //判断pc和移动
    if(isIpad){
      //console.log('isIpad！！！！！！！！！！')
      sidebar.showMobileSideBar = true; //展示移动端侧边栏
      sidebar.collapse = true; //侧边栏折叠状态
      // sidebar.collapseMobile = true; //浮动菜单折叠状态
    }else{
      //console.log('pc！！！！！！！')
      sidebar.showMobileSideBar = false;
      sidebar.collapse = false;
      sidebar.collapseMobile = false;

    }
	})
  onUnmounted(() => {
    window.removeEventListener('resize', updateScreenWidth);
  });

	const logout = () => {
		$http.login.logout({loginId: userInfo.loginId}).then(res => {
			if (res.error) {
				ElMessage.error(res.error.msg || res.error.code || "服务器异常");
			} else {
				router.replace({ name: "Login" });
        // window.document.documentElement.setAttribute("data-theme",'light')
        // document.documentElement.classList.remove('dark');
        // localStorage.removeItem('themeMode');
			}
		});
	};

	// 用户名下拉菜单选择事件
	const router = useRouter();
	const handleCommand = command => {
		if (command == "loginout") logout();
    if (command == "password") {
      passworddialogVisible.value = true;
    }
	};
	const goHome = () => {
		window.location.href = window.location.origin;
	};


  //     };
  var themeMode = ref(null)
  themeMode.value =localStorage.getItem('themeMode') ? + localStorage.getItem('themeMode') : 1 
  const toggleTheme = (index) => {
    // 主题模式存在本地缓存
    sharedState.themeMode = index;
    localStorage.setItem('themeMode', index);
    themeMode.value = index;



    window.document.documentElement.setAttribute(
      "data-theme",
      index == 1 ? "light" : "dark"
    );
    const isDarkMode = document.documentElement.classList.contains('dark');
    // 切换主题模式
    if (isDarkMode) {
      document.documentElement.classList.remove('dark');
    } else {
      index == 0 &&  document.documentElement.classList.add('dark');
    }
  };
  toggleTheme(themeMode.value)
  const screenfull = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      document.documentElement.requestFullscreen();
    }
  };
</script>
<style lang="scss" scoped>
	.header {
		position: fixed;
		z-index: 10;
		box-sizing: border-box;
		width: 100%;
		height: 70px;
		color: #000;
		// background-color: #242f42;
    background: #FFFFFF;
    box-shadow: 0px 2px 12px 0px rgba(30,30,30,0.05);
    @include background_color("background");
    @include box_shadow("box_shadow");
    @include font_color("color");
    font-weight: bold;



		.collapse-btn {
			display: flex;
			justify-content: center;
			align-items: center;
			height: 100%;
			font-size: 22px;
			float: left;
			padding: 0 20px;
			cursor: pointer;
      @include font_color("font_color");
		}

		.logo {
			float: left;
			line-height: 70px;
			font-size: 16px;
			cursor: pointer;
		}

		.header-right {
			float: right;
			padding-right: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      .theme-mode{
        // margin: 0 20px;
        cursor: pointer;
        padding: 4px;
        box-sizing: border-box;
        margin-top: -5px;
        .i-icon{
          border-radius: 20px;
          padding: 5px;
          display: flex;
          align-items: center;
          justify-content: center;
          &.light-icon{
            background: #EEF5FC;
            
          }
        }
      }
      .notify{
        margin: 0px 10px;
      }
      .full-screen{
        margin: 0px 10px;
        cursor: pointer;

      }

			.header-user-con {
				display: flex;
				height: 70px;
				align-items: center;

				.el-dropdown-link {
          @include font_color("color");

					cursor: pointer;
					display: flex;
					align-items: center;
				}

				.el-dropdown-menu__item {
					text-align: center;
				}
			}
		}
	}
</style>
